import { Injectable } from "@angular/core";
import { IIDGrResourcesMapStore } from "./iidGRResourcesMap.store";
import { AbstractInterfaceDataQuery } from "../interfaceDataModel";
import { IID_GR_RESOURCES_MAP } from "@common/interfaces/interfaceData";
import { InterfaceDataQuery } from '../interfaceDataRegistry';
import { InterfaceName } from '@common/interfaces/issueTypeInterface';

@Injectable({
  providedIn: 'root'
})
@InterfaceDataQuery(InterfaceName.GR_RESOURCES_MAP)
export class IIDGrResourcesMapQuery extends AbstractInterfaceDataQuery<IID_GR_RESOURCES_MAP> {

  constructor(protected store: IIDGrResourcesMapStore) {
    super(store);
  }

}
